import { render, staticRenderFns } from "./QuestionInfo.vue?vue&type=template&id=7f2e5140&scoped=true&"
import script from "./QuestionInfo.vue?vue&type=script&lang=js&"
export * from "./QuestionInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuestionInfo.vue?vue&type=style&index=0&id=7f2e5140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e5140",
  null
  
)

export default component.exports